export const Per_Page_Dropdown = async (data) => {
  const a = [];
  for (let i = 5; i <= data; i *= 2) {
    a.push(i);
  }
  a.push(data);
  // console.log(a);

  return a;
};

export const cuppon_type = {
  percentage: "percentage",
  fixedamount: "fixedamount",
};

export const variant_type = {
  Single: 1,
  Double: 2,
  Triple: 3,
};

export const product_coupon = {
  Percentage: "Percentage",
  FixedAmount: "Fixed Amount",
};

export const OrderAssignType = {
  PickupMaterial: 1,
  DeliveredMaterial: 2,
  ReturnMaterial: 3,
  ReDeliveredMaterial: 4,
};

export const product_type = {
  B2B: "Bulk Order",
  B2C: "Home Page",
  SampleRoll: "Sample Roll",
};

export const ImageValidation = {
  files_type: ["jpg", "png", "jpeg", "webp"],
  product: { w: 578, h: 762 },
};

export const RequiredIs = {
  roles: [1],
  service_term: [1, 2, 3, 4],
  service_type: [1, 2, 3],
  product_type: [1, 2, 3, 4],
};

export const Select2Data = async (data, name, other = false) => {
  const result = data?.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const SelectImageData = async (data, name) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name,
    name: name,
    image: data?.image,
  }));

  return result;
};

export const getDimension = async (file) => {
  let reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      var image = new Image();
      image.src = reader.result;
      image.onload = function () {
        resolve({ width: this.width, height: this.height });
      };
    };
    reader.readAsDataURL(file);
  });
};

export function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
}

export const DesignNarrationChange = (e) => {
  const { value } = e.target;
  const capitalizedValue = value
    .split(" ")
    .map((word) => word.trim())
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return capitalizedValue;
};

export const DesignNarrationChangeComa = (e) => {
  const { value } = e.target;
  const capitalizedValue = value
    .split(",")
    .map((word) => word.trim())
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(",");
  return capitalizedValue;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-GB", options).replace(",", "");
};

export const validateImage = async (file, size = 500) => {
  if (!file) {
    return false;
  }

  return true;
  // if (!file) return "Image is required";

  // Check file size (500KB = 500 * 1024 bytes)
  const maxSizeInBytes = size * 1024;
  if (file.size > maxSizeInBytes) {
    return false;
    // return "Image size must be less than or equal to 500KB";
  }

  return new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => {
      const aspectRatio = img.width / img.height;

      if (aspectRatio.toFixed(1) == 0.5) {
        resolve(true);
      } else {
        resolve(false);
        // resolve("Image aspect ratio must be 1:2 (width:height)");
      }
    };
    img.onerror = () => {
      resolve(false);
      // resolve("Invalid image file");
    };
  });
};

export const formatTo12Hour = (timeStr) => {
  if (!timeStr) return "";
  const [hours, minutes] = timeStr.split(":");
  const date = new Date();
  date.setHours(+hours);
  date.setMinutes(+minutes);
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const convertTo12HourFormat = (dateString) => {
  const date = new Date(dateString);

  let hours = date.getHours();
  let minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12; // Convert 0 → 12
  minutes = minutes < 10 ? "0" + minutes : minutes;

  return `${hours}:${minutes} ${ampm}`;
};

export const validateVideo = async (file, size = 5, duration = 40) => {
  return new Promise((resolve) => {
    if (!file) {
      resolve(false);
      return;
    }

    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      const v_duration = video.duration;
      const v_size = file.size / (1024 * 1024); // size in MB

      if (v_duration > duration) {
        resolve(false);
      } else if (v_size > size) {
        resolve(false);
      } else {
        resolve(true);
      }
    };

    video.src = URL.createObjectURL(file);
  });
};

export const formatDateToIST = (isoDate) => {
  const date = new Date(isoDate);
  return date.toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Optional: use 12-hour format with AM/PM
  });
};

export const RoleId = {
  Admin: 1,
  Vendor: 2,
  Customer: 3,
  Expert: 4,
};

export const OrderExpertStatus = {
  Pending: 1,
  Processing: 2,
  Delivered: 3,
};
export const ExpertOrderType = {
  PickupMaterial: 1,
  DropMaterial: 2,
  TransferDelivery: 3,
};
export const ApprovalStatus = {
  Pending: 1,
  Approved: 2,
  Rejected: 3,
  UnderReview: 4,
  OnHold: 5,
};

export const OrderStatusIds = {
  Pending: 1,
  OrderConfirmed: 2,
  PickupMaterial: 3,
  Prossesing: 4,
  ReadyToDelivered: 5,
  Delivered: 6,
  Cancelled: 7,
  RestichingOrders: 8,
  ResheduledOrders: 9,
};

export const ReturnStatusIds = {
  ReturnRequested: 1,
  PickupScheduled: 2,
  ItemPicked: 3,
  Returned: 4,
  RefundProcess: 5,
  Refunded: 6,
  ReturnRejected: 7,
};

export const ReplaceStatusIds = {
  ReplaceRequested: 1,
  StoreItmePickupScheduled: 2,
  StoreItemPicked: 3,
  // CustomerReplaceItem: 4,
  CustomerItemReplaced: 4,
  StoreReplaceItemDelivered: 5,
  ReplaceItemRejected: 6,
};

export const ServiceIds = {
  DineIn: 1,
  RoomService: 2,
  Delivery: 3,
  PickUp: 4,
};

export const Gender = {
  Male: 1,
  Female: 2,
  Other: 3,
};

export const ItemType = {
  Stitching: 1,
  Alteration: 2,
};

export const VendorType = {
  NormalVendor: 1,
  FashionDesigner: 2,
};

export const CouponType = {
  FixedAmount: 1,
  Percentage: 2,
  FreeShipping: 3,
  BuyOneGetOne: 4,
  FreeGift: 5,
};

export const ContactType = {
  Phone: 1,
  Email: 2,
  Address: 3,
  SocialMedia: 4,
};

export const PaymentMethods = {
  Cash: 1,
  Card: 2,
  QR: 3,
};

export const IDS = {
  Role: { List: 1, Add: 2, Edit: 3, Delete: 4 },
  User: { List: 5, Add: 6, Edit: 7, Delete: 8 },
  Country: { List: 9, Add: 10, Edit: 11, Delete: 12 },
  State: { List: 13, Add: 14, Edit: 15, Delete: 16 },
  City: { List: 17, Add: 18, Edit: 19, Delete: 20 },
  Pincode: { List: 21, Add: 22, Edit: 23, Delete: 24 },

  DesignCategory: { List: 37, Add: 38, Edit: 39, Delete: 40 },
  DesignSubCategory: { List: 41, Add: 42, Edit: 43, Delete: 44 },
  DesignChildCategory: { List: 45, Add: 46, Edit: 47, Delete: 48 },

  Vendor: { List: 69, Add: 70, Edit: 71, Delete: 72 },

  Unit: { List: 81, Add: 82, Edit: 83, Delete: 84 },
  Design: { List: 85, Add: 86, Edit: 87, Delete: 88 },
  HomeBanner: { List: 89, Add: 90, Edit: 91, Delete: 92 },
  RatingReview: { List: 93, Add: 94, Edit: 95, Delete: 96 },

  Order: { List: 101, Add: 102, Edit: 103, Delete: 104 },
  Customer: { List: 105, Add: 106, Edit: 107, Delete: 108 },
  Coupon: { List: 109, Add: 110, Edit: 111, Delete: 112 },
  Wallet: { List: 113, Add: 114, Edit: 115, Delete: 116 },
  GalleryImage: { List: 117, Add: 118, Edit: 119, Delete: 120 },

  ApprovalStatus: { List: 137, Add: 138, Edit: 139, Delete: 140 },
  CancelReason: { List: 141, Add: 142, Edit: 143, Delete: 144 },
  ReturnReason: { List: 145, Add: 146, Edit: 147, Delete: 148 },
  FaqCategory: { List: 149, Add: 150, Edit: 151, Delete: 152 },
  Faq: { List: 153, Add: 154, Edit: 155, Delete: 156 },
  AboutUs: { List: 157, Add: 158, Edit: 159, Delete: 160 },
  TermsAndCondition: { List: 161, Add: 162, Edit: 163, Delete: 164 },
  PrivacyPolicy: { List: 165, Add: 166, Edit: 167, Delete: 168 },
  AppSetup: { List: 169, Add: 170, Edit: 171, Delete: 172 },
  SocialLink: { List: 173, Add: 174, Edit: 175, Delete: 176 },
  OfferedDesign: { List: 177, Add: 178, Edit: 179, Delete: 180 },
  CountryCode: { List: 181, Add: 182, Edit: 183, Delete: 184 },
  RejectReasons: { List: 185, Add: 186, Edit: 187, Delete: 188 },

  TimeSlot: { List: 191, Add: 192, Edit: 193, Delete: 194 },
  Help: { List: 195, Add: 196, Edit: 197, Delete: 198 },

  Area: { List: 205, Add: 206, Edit: 207, Delete: 208 },

  Purchase_Order: { List: 228, Add: 229, Edit: 230, Delete: 231 },
  Receiving_Order: { List: 232, Add: 233, Edit: 234, Delete: 235 },
  Supplier: { List: 236, Add: 237, Edit: 238, Delete: 239 },
  AboutUsContent: { List: 240, Add: 241, Edit: 242, Delete: 243 },
  HomeWatchAndShop: { List: 244, Add: 245, Edit: 246, Delete: 247 },

  TheEssence: { List: 248, Add: 249, Edit: 250, Delete: 251 },
  HowWeWork: { List: 252, Add: 253, Edit: 254, Delete: 255 },
  WhyChooseUs: { List: 256, Add: 257, Edit: 258, Delete: 259 },
  Counter: { List: 260, Add: 261, Edit: 262, Delete: 263 },
  CustomerFeedback: { List: 264, Add: 265, Edit: 266, Delete: 267 },
  ReturnPolicy: { List: 268, Add: 269, Edit: 270, Delete: 271 },

  Home: { List: 272, Add: 273, Edit: 274, Delete: 275 },
  Size: { List: 276, Add: 277, Edit: 278, Delete: 279 },
  DesignStock: { List: 280, Add: 281, Edit: 282, Delete: 283 },
  PurchaseDesign: { List: 284, Add: 285, Edit: 286, Delete: 287 },
  WithdrawRequest: { List: 288, Add: 289, Edit: 290, Delete: 291 },
  Blog: { List: 292, Add: 293, Edit: 294, Delete: 295 },
  CustomerLove: { List: 296, Add: 297, Edit: 298, Delete: 299 },
  ContactUs: { List: 300, Add: 301, Edit: 302, Delete: 303 },
  Shape: { List: 304, Add: 305, Edit: 306, Delete: 307 },
  Sale: { List: 308, Add: 309, Edit: 310, Delete: 311 },

  AdvertiseBanner: { List: 316, Add: 317, Edit: 318, Delete: 319 },
  StoreBanner: { List: 320, Add: 321, Edit: 322, Delete: 323 },

  Service_Radius: { List: 328, Add: 329, Edit: 330, Delete: 331 },
  Suitable: { List: 332, Add: 333, Edit: 334, Delete: 335 },
  Fabric: { List: 336, Add: 337, Edit: 338, Delete: 339 },
  Occassion: { List: 340, Add: 341, Edit: 342, Delete: 343 },

  Measurement_Category: { List: 344, Add: 345, Edit: 346, Delete: 347 },
  Measurement_Field: { List: 348, Add: 349, Edit: 350, Delete: 351 },
  Alteration_Type: { List: 352, Add: 353, Edit: 354, Delete: 355 },
  Express_Delivery: { List: 356, Add: 357, Edit: 358, Delete: 359 },

  //new 2
  Vehicle: { List: 360, Add: 361, Edit: 362, Delete: 363 },
  Change_Slot: { List: 364, Add: 365, Edit: 366, Delete: 367 },
  Issue_Type: { List: 368, Add: 369, Edit: 370, Delete: 371 },
  Vendor_Enquiry: { List: 372, Add: 373, Edit: 374, Delete: 375 },
  Expert: { List: 376, Add: 377, Edit: 378, Delete: 379 },
  Vendor_Alteration: { List: 380, Add: 381, Edit: 382, Delete: 383 },
  Spotlight_Type: { List: 384, Add: 385, Edit: 386, Delete: 387 },
  Vendor_Spotlight: { List: 388, Add: 389, Edit: 390, Delete: 391 },
  User_Customization: { List: 392, Add: 393, Edit: 394, Delete: 395 },
  Vendor_Design: { List: 396, Add: 397, Edit: 398, Delete: 399 },
  Refer_History: { List: 400 },
};
